//@flow
type GenericStorefrontPage = {
  path: string,
  label: string,
};

export const GENERIC_STOREFRONT_PAGES: GenericStorefrontPage[] = [
  {
    path: '/products',
    label: 'Todos los productos',
  },
  {
    path: '/products',
    label: 'Todas las categorías',
  },
  {
    path: '/information/about-us',
    label: 'Sobre nosotros',
  },
  {
    path: '/information/complaints',
    label: 'Libro de reclamaciones',
  },
  {
    path: '/information/faq',
    label: 'Preguntas frecuentes',
  },
  {
    path: '/information/refunds',
    label: 'Devoluciones',
  },
  {
    path: '/information/shipping',
    label: 'Envíos y pagos',
  },
  {
    path: '/information/terms',
    label: 'Términos y condiciones',
  },
  {
    path: '/reviews',
    label: 'Reseñas',
  },
];
